import ColorLegendConfigMenu from 'scoreboard/dashboards/widgets/chart/config/chart-color-legend-config-menu'
import TableConfigMenu from 'scoreboard/dashboards/widgets/chart/config/chart-table-config-menu'

/**
 * Used to avoid circular dependencies when retrieving data from
 * get-chart-accessory-metadata.js.
 * Returns the editor for a given chart accessory based on its type
 * @param type - the type of the accessory
 * @returns {*} - the editor for the accessory
 */
function getConfigMenu(type) {
	if (type === 'chart-color-legend') {
		return ColorLegendConfigMenu
	} else if (type === 'chart-table') {
		return TableConfigMenu
	}
}

export default getConfigMenu
getConfigMenu.__filename__ = 'dashboards/widgets/chart/get-config-menu.js'
